import React from 'react';

import { Layout } from '@components/Layout';

export const Loading: React.FC = () => {
  return <Layout title="読み込み中..." loading />;
};
